<div *ngIf="FilteredData && FilteredData.length == 0 && !IsSubmitting" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>
<sk-wave [isRunning]="IsSubmitting"></sk-wave>
<div class="" *ngIf="FilteredData && FilteredData.length > 0 && RequestModel && !IsSubmitting">
    <div class="row align-items-center no-gutters pagerow flex-nowrap">
        <div class="col-auto mr-2">
            <div ngbDropdown class="">
                <button class="btn btn-link btn-nonlink p-0 mr-2" id="selSort" ngbDropdownToggle title="{{'BTN.BTN_SORT_BY' | translate}}"><i class="fas fa-sort mr-2"></i>{{SortByText | translate}}</button>
                <div ngbDropdownMenu aria-labelledby="selSort">
                    <button *ngFor="let row of SortParams" class="dropdown-item pointer" [ngClass]="{'active': row.Name == SortByText}" (click)="SortData(row.Id)" translate>{{!row.Name ? 'ENTITIES.ENTITIES_NONE' : row.Name}}</button>
                </div>
            </div>
        </div>
        <div class="col-auto mr-4" *ngIf="FilteredData && FilteredData.length > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="FilteredData.length" [pageSize]="25" [(page)]="CurrentPageNumber" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
        </div>
        <div class="col-auto" *ngIf="FilteredData"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{FilteredData.length}}</B></div>
    </div>
    <div class="row">
        <div class="col">
            <div class="glitchConsole" *ngIf="IsSubmitting == false && FilteredData && FilteredData.length > 0">
                <div class="grdGrid">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                          <th scope="col" translate>LBL.IDENTIFIER_TOKEN</th>
                        <th scope="col" translate>ENTITIES.ENTITIES_STATUS</th>
                        <th scope="col" translate>LBL.ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of DevicesForView">
                          <td>
                              {{row.IdentifierToken}}
                              <span class="badge badge-secondary" *ngIf="row.IdentifierToken == IdentifierToken" translate>LBL.YOUR_DEVICE</span>
                          </td>
                        <td translate>{{row.DeviceStatus ? 'LBL.ACTIVE' : 'LBL.INACTIVE'}}</td>
                        <td>
                          <button type="button" class="btn btn-primary" *ngIf="row.DeviceStatus && IdentifierToken != row.IdentifierToken" [disabled]="IdentifierToken == row.IdentifierToken" (click)="UpdateDeviceStatus(row)" translate>BTN.BTN_DEACTIVATE</button>
                          <button type="button" class="btn btn-default" *ngIf="!row.DeviceStatus || IdentifierToken == row.IdentifierToken" [disabled]="true" translate>BTN.BTN_DEACTIVATE</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                 
                </div>
            </div>

            <ng-template #content let-c="close" let-d="dismiss">
              <div class="modal-header">
                  <h6 class="modal-title" translate>
                      TITLE.TITLE_DEACTIVATE_ALL
                  </h6>
                  <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                  <div class="row">
                    <progress-bar style="width:100%" *ngIf="Progress > 0" [progress]="Progress" [color]="'#dc4646'">
                    </progress-bar>
                  </div>
            
                  <div class="row col-md-10 offset-md-1">
                      <label class="control-label" translate>MSGTEXT.MSG_DEACTIVATE_ALL_IN_PROGRESS</label>
                  </div>
            
              </div>
            
            </ng-template>
        </div>
    </div>
</div>
